// Components/ui
import { Box } from '@mui/material';
import { SubsectionHeaderWithButton } from '../../layout';
import { Body } from './components';
// Types
import { NewAddress } from '../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  whatsapps: Array<NewAddress | IContactAddress>;
  handleAdd: () => void;
};
const Whatsapps = ({ whatsapps, handleAdd }: Props) => {
  return (
    <Box sx={{ width: '100%' }}>
      <SubsectionHeaderWithButton handleAdd={handleAdd} title={'WhatsApp'} />
      <Body whatsapps={whatsapps} />
    </Box>
  );
};

export default Whatsapps;
